/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import {
  EngineParametersRecord,
  EngineParametersProps,
} from 'src/store/generated/engine-parameters-record.generated';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface MaintenanceParametersProps {
  endingHobbs: number | null;
  airframeTime: number | null;
  totalLandings: number | null;
  engine1: EngineParametersProps | null;
  engine2: EngineParametersProps | null;
}

export class MaintenanceParametersRecord extends Record<MaintenanceParametersProps>({
  endingHobbs: null as any,
  airframeTime: null as any,
  totalLandings: null as any,
  engine1: null as any,
  engine2: null as any,
}) {
  public static fromJS(json: {
    endingHobbs: number | null;
    airframeTime: number | null;
    totalLandings: number | null;
    engine1: any;
    engine2: any;
  }): MaintenanceParametersRecord {
    if (json == null) {
      throw new Error('MaintenanceParametersRecord.fromJS: parameter cannot be null');
    }
    return new MaintenanceParametersRecord({
      endingHobbs: json.endingHobbs,
      airframeTime: json.airframeTime,
      totalLandings: json.totalLandings,
      engine1: json.engine1 != null ? new EngineParametersRecord(json.engine1) : null,
      engine2: json.engine2 != null ? new EngineParametersRecord(json.engine2) : null,
    });
  }

  public static fromJSUnsafe(json: {
    endingHobbs: number | null;
    airframeTime: number | null;
    totalLandings: number | null;
    engine1: any;
    engine2: any;
  }): [MaintenanceParametersRecord, Error[]] {
    if (json == null) {
      throw new Error('MaintenanceParametersRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new MaintenanceParametersRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      endingHobbs: tryOrDefault(
        () => json.endingHobbs,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      airframeTime: tryOrDefault(
        () => json.airframeTime,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      totalLandings: tryOrDefault(
        () => json.totalLandings,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      engine1: tryOrDefault(
        () => (json.engine1 != null ? new EngineParametersRecord(json.engine1) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      engine2: tryOrDefault(
        () => (json.engine2 != null ? new EngineParametersRecord(json.engine2) : null),
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: MaintenanceParametersProps) {
    super(props);
    if (props == null) {
      throw new Error('MaintenanceParametersRecord constructor parameter cannot be null');
    }
  }
}

export abstract class MaintenanceParametersViewModelBase implements MaintenanceParametersProps {
  protected readonly _props: MaintenanceParametersProps;
  private _json?: MaintenanceParametersProps;

  get endingHobbs(): number | null {
    return this._props.endingHobbs;
  }
  get airframeTime(): number | null {
    return this._props.airframeTime;
  }
  get totalLandings(): number | null {
    return this._props.totalLandings;
  }
  get engine1(): EngineParametersProps | null {
    return this._props.engine1;
  }
  get engine2(): EngineParametersProps | null {
    return this._props.engine2;
  }

  constructor(props: MaintenanceParametersProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        endingHobbs: this._props.endingHobbs,
        airframeTime: this._props.airframeTime,
        totalLandings: this._props.totalLandings,
        engine1: this._props.engine1,
        engine2: this._props.engine2,
      };
    }
    return this._json;
  }
}
